
<script setup>

  import { ref, watch } from 'vue';

  import { v4 as uuidv4 } from 'uuid';

  const props = defineProps( [ 'cues' ] );

  const wrapper = ref( null );

  const parsed = ref( null );

  const highlight = [ 'text-black', 'bg-amber-200' ];

  function parseText( value ) {
  
    const match = value.match( /<v.*?>(?<text>.*?)<\/v>/ );
  
    return match?.groups.text || value;
  
  }
  
  function createRef( cue ) {

    const el = ref( null );
    
    cue.addEventListener( 'enter', event => {
      
      el.value.classList.add( ...highlight );

      scrollTo( el );
    
    } );
    
    cue.addEventListener( 'exit', event => el.value.classList.remove( ...highlight ) );

    return el;
    
  }

  function scrollTo( el ) {

    const { y: wrapperY, height: wrapperHeight } = wrapper.value.getBoundingClientRect();

    const { y: elY, height: elHeight } = el.value.getBoundingClientRect();

    wrapper.value.scrollTop = wrapper.value.scrollTop + ( elY + elHeight / 2 ) - ( wrapperY + wrapperHeight / 2 );

  }

  watch( () => props.cues, cues => {
    
    if ( ! cues ) return;
    
    parsed.value = cues.map( cue => {
      
      const el = createRef( cue );
      
      const text = parseText( cue.text );
      
      const key = uuidv4();
      
      return { el, text, key };
    
    } );
    
  }, { immediate: true } );

</script>

<template>
  
  <div ref="wrapper" class="h-24 px-3 py-2 text-sm leading-loose border border-neutral-300 overflow-y-scroll scroll-smooth">
    
    <template v-for="cue in parsed" :key="cue.key">
    
      <span :ref="el => cue.el = el" v-html="cue.text" />
      
      <span>&nbsp;</span>
      
    </template>
    
  </div>
  
</template>
